import { OdsDiagnosticSessionRequest } from '../schema/OdsDiagnosticSessionRequest';
import { ODSCLIENTNAME, ODSDIAGNOSTICSESSIONENDPOINT } from '../FeedbackConstants';

export default function createOdsDiagnosticsSession(
    odsDiagnosticSessionRequest: OdsDiagnosticSessionRequest,
    token: any
): Promise<Response> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json; charset=utf-8');
    headers.append('Authorization', `Bearer ${token}`);
    headers.append('Client-Name', ODSCLIENTNAME);

    let requestInit: RequestInit = {
        method: 'POST',
        credentials: 'omit',
    };

    requestInit.body = JSON.stringify(odsDiagnosticSessionRequest);
    requestInit.headers = headers;

    return fetch(ODSDIAGNOSTICSESSIONENDPOINT, requestInit);
}
